<app-table
  [pageSize]="7"
  [allowedPageSizes]="[7]"
  [showPageSizeSelector]="false"
  [data]="requests"
  [columns]="requestColumns"
></app-table>